"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalArticleItem = exports.ArticleItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _TextWithSyllabification = _interopRequireDefault(require("../../../TextWithSyllabification/TextWithSyllabification"));
var _reactRouterDom = require("react-router-dom");
var _PagePicture = _interopRequireDefault(require("../../../PagePicture/PagePicture"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.articleItem .title {\n  font-size: 26px;\n  line-height: 1.23; }\n";
  const fileName = "ArticleItem_ArticleItem";
  const element = document.querySelector("style[data-sass-component='ArticleItem_ArticleItem']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ArticleItem = _ref => {
  let {
    item,
    lang,
    isLast
  } = _ref;
  const {
    title,
    id,
    pictures_gallery,
    main_tag,
    article_lead
  } = item || {};
  const media = pictures_gallery?.map(picture => {
    return {
      src: picture[0]?.tablet.url,
      type: 'IMAGE'
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `articleItem sia-padding-05-bottom ${isLast ? '' : 'sia-border-01-bottom sia-margin-03-bottom'}`
  }, media && media.length > 0 && /*#__PURE__*/_react.default.createElement(_PagePicture.default, {
    src: media[0].src,
    aspectRatio: "362/200"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: " sia-padding-02-inline "
  }, main_tag && main_tag?.length === 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "main-tag sia-text-01"
  }, /*#__PURE__*/_react.default.createElement("span", null, main_tag[0]?.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-10 sia-margin-01-top sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, title)), article_lead && article_lead?.length === 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-10 sia-margin-02-top sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, article_lead[0])), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "link",
    to: `/${lang}/cms/node/${id}`
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "page-action-down-32"
  }))));
};
exports.ArticleItem = ArticleItem;
const ExternalArticleItem = _ref2 => {
  let {
    item,
    isLast
  } = _ref2;
  const {
    title,
    source,
    link,
    lead
  } = item || {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `articleItem sia-padding-05-bottom ${isLast ? '' : 'sia-border-01-bottom sia-margin-03-bottom'}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " sia-padding-02-inline "
  }, source && source?.length === 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: `sia-text-01`
  }, /*#__PURE__*/_react.default.createElement("span", null, source[0]?.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "title sia-text-10 sia-margin-01-top sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, title)), lead && lead.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-10 sia-margin-02-top sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, lead)), /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    href: link?.original_url,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "page-action-down-32"
  }))));
};
exports.ExternalArticleItem = ExternalArticleItem;